// extracted by mini-css-extract-plugin
module.exports = {"tag":"home-usedcar_tag__1e9Va","brand":"home-usedcar_brand__21kzo"};